var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.75C9.6527 2.75 7.74991 4.65279 7.74991 7C7.74991 9.34721 9.6527 11.25 11.9999 11.25C14.3471 11.25 16.2499 9.34721 16.2499 7C16.2499 4.65279 14.3471 2.75 11.9999 2.75ZM6.24991 7C6.24991 3.82436 8.82427 1.25 11.9999 1.25C15.1755 1.25 17.7499 3.82436 17.7499 7C17.7499 10.1756 15.1755 12.75 11.9999 12.75C8.82427 12.75 6.24991 10.1756 6.24991 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65991 22C2.65991 17.5791 6.99703 14.25 11.9999 14.25C17.0028 14.25 21.3399 17.5791 21.3399 22C21.3399 22.4142 21.0041 22.75 20.5899 22.75C20.1757 22.75 19.8399 22.4142 19.8399 22C19.8399 18.6809 16.477 15.75 11.9999 15.75C7.52278 15.75 4.15991 18.6809 4.15991 22C4.15991 22.4142 3.82413 22.75 3.40991 22.75C2.9957 22.75 2.65991 22.4142 2.65991 22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.09ca34088c143227eb805a96c987d0fe.svg";
export { ForwardRef as ReactComponent };